<script>
  import { Modal } from 'bootstrap';
  import { onMount, getContext } from 'svelte';
  import FormTextarea from './FormControls/FormTextarea.svelte';
  import { configItem } from './Helper';
  import Loader from '../components/Loader.svelte';
  let initialBoardDateModal;
  let isLoading = false;
  onMount(() => {
    initialBoardDateModal = new Modal(document.getElementById('initialBoardDateModal'), {
      keyboard: false,
    });
  });
  import * as yup from 'yup';
  const showDialog = getContext('showDialog');
  export let success = () => {};
  export const show = (data) => {
    isLoading = false;
    $form = data;
    $form.initialBoardDateUpdateReason = '';
    initialBoardDateModal.show();
  };
  export const showModal = () => {
    initialBoardDateModal.show();
  };
  let defaultValue = {
    initialBoardDate: '',
    tasks: [],
  };
  import DatePicker from './Flatpickr/DatePicker.svelte';
  import { createForm } from 'svelte-forms-lib';
  import { client } from 'root/api/index.js';
  const { form, errors, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      initialBoardDate: yup.string().required('Initial Board Date is required'),
    }),
    onSubmit: (values) => {
      client
        .taskInitialBoardDate(values)
        .then(() => {
          initialBoardDateModal.hide();
          success($form);
        })
        .catch((error) => {
          showDialog({
            message: `${error}`,
            okFunc: () => {
              isLoading = false;
              showModal();
            },
          });
          initialBoardDateModal.hide();
        });
    },
  });
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="initialBoardDateModal"
  tabindex="-1"
  aria-labelledby="initialBoardDateModal"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    {#if isLoading}
      <div class="modal-content p-5 text-center">
        <div class="p-5">
          <Loader Style="loader-block" />
        </div>
      </div>
    {:else}
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title font-size-14"
            id="exampleModalLabel"
          >
            Change Initial Board Date
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div
              class="form-group position-relative priority-dropdown-modal {$errors.initialBoardDate
                ? 'error'
                : ''}"
            >
              <span class="d-inline-block mb-3 color-lead"
                >{$form?.tasks?.length || 0} Tasks selected</span
              >
              <div class="form-group mb-3">
                <label
                  for="initialBoardDate"
                  class="form-label">Select Initial Board Date</label
                >
                <DatePicker
                  style="active select-border"
                  placeholder="Initial Board Date"
                  on:change={(value) => {
                    $errors.initialBoardDate = null;
                    $form.initialBoardDate = value.detail[1];
                  }}
                  value={$form.initialBoardDate}
                />
                {#if $errors.initialBoardDate}
                  <div class="formError">{$errors.initialBoardDate}</div>
                {/if}
              </div>
            </div>
          </div>
          <div class="form-group">
            <FormTextarea
              label="Please tell us why you are making this change?"
              placeholder="Enter Notes (Optional)"
              name="initialBoardDateUpdateReason"
              bind:value={$form.initialBoardDateUpdateReason}
              maxLength={configItem.maxLength.description}
              rows="6"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
            data-bs-dismiss="modal">Cancel</button
          >
          <button
            type="button"
            class="btn btn-primary m-0 px-4 font-size-12"
            on:click={() => {
              isLoading = true;
              handleSubmit();
            }}>Done</button
          >
        </div>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .button-tabber-modal button {
    border: 0px !important;
    border-radius: 6px !important;
  }
  .button-tabber-modal button.active {
    background-color: #fff !important;
  }
  .shadow {
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  }
  .active,
  .active:hover {
    background-color: $blue-color;
    color: $white-color;
    border: 1px solid $blue-color;
  }
</style>
